const styles = (theme) => ({
  accordionRoot: {
    border: '1px solid #D9DCDF',
    boxShadow: 'none',
  },
  accordionRounded: {
    borderRadius: '8px !important',
  },
  accordionSummaryRoot: {
    '&:not(.no-expand)': {
      paddingRight: 0,
    },
    userSelect: 'text',

    '&:hover:not(.Mui-disabled)': {
      cursor: 'initial'
    }
  },
  accordionSummaryExpanded: {
    minHeight: '48px !important',
    margin: '0 0 0 0 !important',
  },
  accordionSummaryContent: {
    margin: 0,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  accButtonIconEdgeEnd: {
    marginRight: '0 !important'
  },
  linkCounter: {
    fontSize: 12,
  }
});

export default styles;